import { Iso8601DateString } from '@connect-x-app/shared-types';

export enum NotificationType {
  ACCESS_DENIED = 'access-denied',
  ACCESS_GRANTED = 'access-granted',
  ACCESS_REQUEST = 'access-requested',
  EXTERNAL_MENTION = 'external-mention',
  MENTION = 'mention',
}

export enum NotificationChannelType {
  CUSTOM = 'custom',
  MAIN = 'main',
}

export enum NotificationStatus {
  DISMISSED = 'dismissed',
  SENT = 'sent',
}

export type NotificationLink = {
  channelId?: string;
  channelType?: NotificationChannelType;
  messageId?: string;
  roomId: string;
};

export type Notification = {
  body: string;
  createdAt: Iso8601DateString;
  dismissedAt: Iso8601DateString | null;
  id: string;
  link: NotificationLink;
  status: NotificationStatus;
  title: string;
  type: NotificationType;
};

export type NotificationsResponse = {
  items: Notification[];
  limit: number;
  offset: number;
  total: number;
  unreadCount: number;
};
